import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageWrapperProps {
  title?: string;
  children: React.ReactNode;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ title, children }) => {
  return (
    <Box sx={{ padding: '16px 24px' }}>
      {title && (
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            fontWeight: 600, 
            color: '#1976d2',
            marginBottom: '16px' 
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};